<template>
	<!-- <v-container> -->
		<v-row
			align 	= "center"
			justify = "center"
		>
			<v-col 
				xl 	  = "10" 
				lg 	  = "10" 
				md 	  = "10" 
				sm 	  = "12" 
				cols  = "12">
				<v-card outlined>
					<v-card-title 
						
						class  = "body-2 justify-center pa-1 secondary text-uppercase font-weight-bold white--text"
					>
						<v-icon 
							small 
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>
							mdi-arrow-left-circle
						</v-icon>

						<v-spacer></v-spacer>
						
						<v-icon 
							small 
							color  = "primary"
							class  = "mx-1"
							
						>
							mdi-account-circle
						</v-icon>
						<span 
							v-text = "$ml.get('user')" 
						></span>
						
						<v-spacer></v-spacer>

					</v-card-title>
					<v-divider></v-divider>
					<v-card-text
						class = "pa-1"
					>
						<!-- <v-card> -->
      						<!-- fixed-tabs -->
						<v-tabs   
						    grow

      						dark 
      						height 	= "35"  
      						v-model = "tab"
      					>
      					<!-- centered -->
							<v-tab >
								<v-icon 
									small 
									class = "mx-2"
								>
									mdi-account-plus
								</v-icon>
								{{ $ml.get('register') }}
							</v-tab>
							<v-tab>
								<v-icon 
									small 
									class = "mx-2"
								>
									mdi-account-details
								</v-icon>								
								{{ $ml.get('list') }}

							</v-tab>
							<v-tab
								v-show = "currentUser && currentUser.user && currentUser.user.roleId == 1"
							>
								<v-icon 
									small 
									class = "mx-2"
								>
									mdi-account-multiple
								</v-icon>								
								{{ $ml.get('roles') }}

							</v-tab>
							<v-tab
								v-show = "currentUser && currentUser.user && currentUser.user.roleId == 1"
							>
								<v-icon 
									small 
									class = "mx-2"
								>
									mdi-folder-account
								</v-icon>								
								{{ $ml.get('resources') }}

							</v-tab>
							<!-- <v-tab>
								<v-icon small> mdi-account-circle</v-icon> network
							</v-tab> -->
						</v-tabs>
						<!-- </v-card>	 -->
						<!-- <v-divider></v-divider>					 -->
						<v-tabs-items  
							v-model = "tab"
						>
								
							<v-tab-item>
								<register/>
							</v-tab-item>
							<v-tab-item>
								<user_list/>
							</v-tab-item>
							<v-tab-item>
								<roles/>
							</v-tab-item>
							<v-tab-item>
								<resources/>
							</v-tab-item>
							<v-tab-item>
								<user_tracking/>
							</v-tab-item>
						</v-tabs-items>
					<!-- <v-divider></v-divider>					 -->
					</v-card-text>
					<!-- <v-card-actions>
					</v-card-actions> -->
				</v-card>
			</v-col>
		</v-row>
	<!-- </v-container> -->
</template>
<script>
import user_list 		from '@/components/user/user_list.vue'
import register 		from '@/components/user/register.vue'
import user_tracking 	from '@/components/user/user_tracking.vue'
import roles 			from "@/components/user/roles.vue"
import resources 		from "@/components/user/resources.vue"
	export default{
		name 		: 'user',
		components 	: { 
			user_list, 
			register, 
			user_tracking, 
			roles,
			resources
		},
		data : ()=>({
			select 	: '',
			tab 	: null,
		}), // data
		created(){
			if (this.$store.state.auth.user){
	        // console.log(this.$store.state.auth.user.user.roleId, 'auth')
		        if (this.$store.state.auth.user.user.roleId == 3) {
		        	this.$router.push('dashboard')
		        }
	      	}
		}, // created 
		computed : {
			currentUser(){
				return this.$store.getters["auth/user"];
			}
		}, // computed
		

	};
</script>